export default __webpack_public_path__ + "static/media/background_3_large.2a694f7a.jpg";